import { api, unwrap } from './client';
import { documentFromApi, documentToApi } from './_transforms';

export async function listDocuments({ q, category, page = 0, size = 24 } = {}) {
  const params = { page, size };
  if (q) params.q = q;
  if (category) params.category = category.toUpperCase();
  const data = await unwrap(api.get('/api/documents', { params }));
  return {
    content: (data.content || []).map(documentFromApi),
    totalElements: data.totalElements,
    totalPages: data.totalPages,
    number: data.number,
  };
}

export async function getDocument(id) {
  const data = await unwrap(api.get(`/api/documents/${id}`));
  return documentFromApi(data);
}

export async function createDocument(payload) {
  const data = await unwrap(api.post('/api/documents', documentToApi(payload)));
  return documentFromApi(data);
}

export async function updateDocument(id, payload) {
  const data = await unwrap(api.put(`/api/documents/${id}`, documentToApi(payload)));
  return documentFromApi(data);
}

export function deleteDocument(id) {
  return unwrap(api.delete(`/api/documents/${id}`));
}
